import type { SurveyPage } from '@/models/surveyPage';

export const filterPage = (page: SurveyPage) => {
   const questions = page.questions.filter((question) => {
      if (
         ['checkbox', 'radio', 'select'].includes(
            question.question_type?.slug ?? '',
         )
      ) {
         if (
            (
               question.linked_choices?.filter(
                  (choice) => !choice.is_limit_overflowed,
               ) ?? []
            ).length > 0 &&
            !question.is_limit_overflowed &&
            question.is_visible
         ) {
            return question;
         }
      } else if (!question.is_limit_overflowed && question.is_visible) {
         return question;
      }
   });

   if (questions.length > 0) {
      return page;
   }
};
